import { useEffect, useState } from "react";
import { getRooms, expressInterest, cancelInterest, getUserInterest, declareCautionForRoom } from "../../firebase/services";
import { EmptyState, Spinner, Modal, Btn } from "../../components/UI";

const LOYER = 27500;
const STATUS = {
  vacant: { icon: "🟢", label: "Disponible maintenant", color: "#2d6a0a", bg: "#e8f5e0" },
  soon:   { icon: "🟡", label: "Bientôt disponible",    color: "#8a4c00", bg: "#fff3e0" },
};
const METHODS = ["Orange Money", "Wave", "Espèces", "Virement"];
const METHOD_ICONS = { "Orange Money":"🟠", "Wave":"🌊", "Espèces":"💵", "Virement":"🏦" };

export default function StudentListings({ userId, userName, myRoomId, onBack }) {
  const [rooms, setRooms]           = useState([]);
  const [loading, setLoading]       = useState(true);
  const [interests, setInterests]   = useState({});
  const [modalRoom, setModalRoom]   = useState(null);
  const [modalType, setModalType]   = useState("interest"); // "interest" | "caution"
  const [message, setMessage]       = useState("");
  const [cautionMethod, setCautionMethod] = useState("Orange Money");
  const [cautionRef, setCautionRef]       = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successId, setSuccessId]   = useState(null);

  useEffect(() => {
    const unsub = getRooms(async (data) => {
      const available = data.filter(r => r.paymentStatus === "vacant" || r.availableSoon);
      setRooms(available);
      setLoading(false);
      if (!userId) return;
      const map = {};
      for (const r of available) {
        const interest = await getUserInterest(r.id, userId);
        if (interest) map[r.id] = interest;
      }
      setInterests(map);
    });
    return unsub;
  }, [userId]);

  const handleInterest = async () => {
    if (!modalRoom || !userId) return;
    setSubmitting(true);
    const result = await expressInterest(modalRoom.id, {
      userId, userName, myRoomId, message: message.trim()
    });
    setSubmitting(false);
    if (!result?.alreadyExists && !result?.error) {
      setInterests(p => ({ ...p, [modalRoom.id]: { status: "pending" } }));
      setSuccessId(modalRoom.id);
      setTimeout(() => setSuccessId(null), 4000);
    }
    setModalRoom(null);
    setMessage("");
  };

  const handleCaution = async () => {
    if (!modalRoom || !userId) return;
    if (cautionMethod !== "Espèces" && !cautionRef.trim()) return;
    setSubmitting(true);
    const interest = interests[modalRoom.id];
    await declareCautionForRoom(myRoomId, modalRoom.id, {
      amount: LOYER,
      method: cautionMethod,
      reference: cautionRef.trim(),
      interestId: interest?.id || null
    });
    setSubmitting(false);
    setInterests(p => ({ ...p, [modalRoom.id]: { ...p[modalRoom.id], cautionDeclared: true } }));
    setModalRoom(null);
    setCautionRef("");
  };

  const handleCancel = async (roomId) => {
    await cancelInterest(roomId, userId);
    setInterests(p => { const n = { ...p }; delete n[roomId]; return n; });
  };

  const openCautionModal = (room) => {
    setModalRoom(room);
    setModalType("caution");
    setCautionRef("");
    setCautionMethod("Orange Money");
  };

  if (loading) return <div style={S.page}><Spinner /></div>;

  return (
    <div style={S.page}>
      <div style={S.header}>
        {onBack && <button style={S.back} onClick={onBack}>←</button>}
        <span style={S.htitle}>Chambres disponibles</span>
      </div>

      <div style={S.scroll}>
        {rooms.length === 0 ? (
          <EmptyState icon="🏠" title="Aucune chambre disponible" subtitle="Revenez bientôt !" />
        ) : rooms.map(room => {
          const st       = room.availableSoon ? STATUS.soon : STATUS.vacant;
          const interest = interests[room.id];

          return (
            <div key={room.id} style={S.card}>
              <div style={{ ...S.band, background: st.bg }}>
                <span>{st.icon}</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: st.color }}>{st.label}</span>
              </div>
              <div style={S.body}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
                  <p style={S.roomTitle}>Chambre {room.number}</p>
                  {room.availableFrom && <span style={S.dateChip}>📅 {room.availableFrom}</span>}
                </div>
                {room.description && <p style={S.desc}>{room.description}</p>}
                <p style={S.price}>
                  {(room.loyer || LOYER).toLocaleString("fr-FR")}
                  <span style={{ fontSize:13, fontWeight:400 }}> FCFA/mois</span>
                </p>
                <p style={{ fontSize:12, color:"#7a90a8", margin:"0 0 10px" }}>
                  🏦 Caution : {(room.loyer || LOYER).toLocaleString("fr-FR")} FCFA (1 mois)
                </p>

                {/* Statut selon l'intérêt */}
                {!interest && (
                  <button style={S.intBtn} onClick={() => { setMessage(""); setModalRoom(room); setModalType("interest"); }}>
                    🙋 Je suis intéressé(e)
                  </button>
                )}

                {interest?.status === "pending" && (
                  <div>
                    <div style={{ ...S.statusBox, background:"#fff9e6", border:"1px solid #f5d8a0" }}>
                      <span>⏳</span>
                      <p style={{ fontSize:12, color:"#8a6a00", margin:0, fontWeight:600 }}>
                        Demande envoyée — en attente de réponse IAM
                      </p>
                    </div>
                    <button style={S.cancelBtn} onClick={() => handleCancel(room.id)}>Annuler ma demande</button>
                  </div>
                )}

                {interest?.status === "accepted" && !interest?.cautionDeclared && (
                  <div>
                    <div style={{ ...S.statusBox, background:"#e8f5e0", border:"1px solid #a8d880" }}>
                      <span>✅</span>
                      <p style={{ fontSize:12, color:"#2d6a0a", margin:0, fontWeight:600 }}>
                        Demande acceptée ! Payez la caution pour bloquer la chambre.
                      </p>
                    </div>
                    <button style={S.cautionBtn} onClick={() => openCautionModal(room)}>
                      🏦 Payer la caution — {(room.loyer || LOYER).toLocaleString("fr-FR")} FCFA
                    </button>
                  </div>
                )}

                {(interest?.status === "accepted" && interest?.cautionDeclared) && (
                  <div style={{ ...S.statusBox, background:"#e3f1fb", border:"1px solid #90bde0" }}>
                    <span>🏦</span>
                    <p style={{ fontSize:12, color:"#1a3a5c", margin:0, fontWeight:600 }}>
                      Caution déclarée — en attente de confirmation IAM
                    </p>
                  </div>
                )}

                {interest?.status === "refused" && (
                  <div>
                    <div style={{ ...S.statusBox, background:"#fdecea", border:"1px solid #f5b8b8" }}>
                      <span>❌</span>
                      <p style={{ fontSize:12, color:"#a32d2d", margin:0, fontWeight:600 }}>
                        Demande refusée par IAM
                      </p>
                    </div>
                    <button style={S.retryBtn} onClick={() => { setMessage(""); setModalRoom(room); setModalType("interest"); }}>
                      🔄 Postuler à nouveau
                    </button>
                  </div>
                )}

                {successId === room.id && !interest && (
                  <div style={{ ...S.statusBox, background:"#e8f5e0", border:"1px solid #a8d880" }}>
                    <span>✅</span>
                    <p style={{ fontSize:12, color:"#2d6a0a", margin:0, fontWeight:600 }}>Votre intérêt a été envoyé à IAM !</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal intérêt */}
      <Modal open={!!modalRoom && modalType === "interest"} onClose={() => setModalRoom(null)} title="Manifester mon intérêt">
        {modalRoom && (
          <div>
            <div style={S.modalSummary}>
              <p style={{ fontSize:13, fontWeight:700, color:"#1a2a3a", margin:"0 0 2px" }}>Chambre {modalRoom.number}</p>
              <p style={{ fontSize:12, color:"#5a7a9a", margin:0 }}>
                {(modalRoom.loyer || LOYER).toLocaleString("fr-FR")} FCFA/mois · Caution : {(modalRoom.loyer || LOYER).toLocaleString("fr-FR")} FCFA
              </p>
            </div>
            <div style={{ background:"#fff9e6", borderRadius:10, padding:"10px 12px", marginBottom:14, fontSize:12, color:"#8a6a00" }}>
              ℹ️ Si votre demande est acceptée, vous devrez payer une caution d'un mois pour bloquer la chambre.
            </div>
            <p style={{ fontSize:12, color:"#4a6a8a", fontWeight:500, marginBottom:6 }}>Message pour IAM (optionnel)</p>
            <textarea
              style={{ width:"100%", border:"1.5px solid #d0dce8", borderRadius:10, padding:"10px 12px", fontSize:14, fontFamily:"inherit", background:"#f7fafd", color:"#1a2a3a", resize:"none", outline:"none", boxSizing:"border-box" }}
              value={message} onChange={e => setMessage(e.target.value)}
              placeholder="Ex: Je suis disponible dès le 1er juillet..." rows={3}
            />
            <div style={{ display:"flex", flexDirection:"column", gap:8, marginTop:10 }}>
              <Btn variant="primary" onClick={handleInterest} disabled={submitting}>
                {submitting ? "Envoi..." : "🙋 Confirmer mon intérêt"}
              </Btn>
              <Btn variant="ghost" onClick={() => setModalRoom(null)}>Annuler</Btn>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal paiement caution */}
      <Modal open={!!modalRoom && modalType === "caution"} onClose={() => setModalRoom(null)} title="Payer la caution">
        {modalRoom && (
          <div>
            <div style={S.modalSummary}>
              <p style={{ fontSize:13, fontWeight:700, color:"#1a2a3a", margin:"0 0 4px" }}>Chambre {modalRoom.number} — Caution de réservation</p>
              <p style={{ fontSize:20, fontWeight:800, color:"#1a3a5c", margin:0, fontFamily:"'Barlow Condensed',sans-serif" }}>
                {(modalRoom.loyer || LOYER).toLocaleString("fr-FR")} FCFA
              </p>
            </div>

            <div style={{ background:"#e8f5e0", borderRadius:10, padding:"10px 12px", marginBottom:14, fontSize:12, color:"#2d6a0a" }}>
              ✅ En payant cette caution, vous bloquez la chambre {modalRoom.number}. Elle vous sera remboursée lors de votre départ.
            </div>

            <p style={{ fontSize:13, fontWeight:600, color:"#2a4a6a", marginBottom:8 }}>Mode de paiement</p>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:8, marginBottom:14 }}>
              {METHODS.map(m => (
                <button key={m}
                  style={{ padding:"10px", borderRadius:10, border: cautionMethod===m ? "1.5px solid #2e86c1" : "1.5px solid #d0dce8", background: cautionMethod===m ? "#e3f1fb" : "white", color: cautionMethod===m ? "#1a3a5c" : "#5a7a9a", cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:600, display:"flex", flexDirection:"column", alignItems:"center", gap:4 }}
                  onClick={() => setCautionMethod(m)}
                >
                  <span style={{ fontSize:18 }}>{METHOD_ICONS[m]}</span>{m}
                </button>
              ))}
            </div>

            {cautionMethod !== "Espèces" && (
              <>
                <p style={{ fontSize:13, fontWeight:600, color:"#2a4a6a", marginBottom:6 }}>Référence de transaction</p>
                <input
                  style={{ width:"100%", border:"1.5px solid #d0dce8", borderRadius:10, padding:"11px 12px", fontSize:14, fontFamily:"inherit", background:"#f7fafd", color:"#1a2a3a", outline:"none", boxSizing:"border-box", marginBottom:14 }}
                  value={cautionRef}
                  onChange={e => setCautionRef(e.target.value)}
                  placeholder={cautionMethod === "Orange Money" ? "Ex: OM-20260609-XXXXX" : "Référence"}
                />
              </>
            )}

            <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
              <Btn variant="primary" onClick={handleCaution}
                disabled={submitting || (cautionMethod !== "Espèces" && !cautionRef.trim())}>
                {submitting ? "Envoi..." : "🏦 Déclarer le paiement de la caution"}
              </Btn>
              <Btn variant="ghost" onClick={() => setModalRoom(null)}>Annuler</Btn>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

const S = {
  page:   { display:"flex", flexDirection:"column", height:"100%", background:"#f5f8fc", fontFamily:"'Barlow',sans-serif" },
  header: { background:"#1a3a5c", padding:"10px 14px", display:"flex", alignItems:"center", gap:10 },
  back:   { background:"none", border:"none", color:"white", fontSize:20, cursor:"pointer", padding:"0 8px 0 0" },
  htitle: { fontSize:15, fontWeight:700, color:"white" },
  scroll: { flex:1, overflowY:"auto", padding:"12px 16px 80px" },
  card:   { background:"white", borderRadius:16, marginBottom:14, border:"0.5px solid #d0dce8", overflow:"hidden" },
  band:   { padding:"8px 14px", display:"flex", alignItems:"center", gap:6 },
  body:   { padding:"12px 14px" },
  roomTitle: { fontSize:17, fontWeight:800, color:"#1a2a3a", margin:0, fontFamily:"'Barlow Condensed',sans-serif" },
  desc:   { fontSize:13, color:"#4a6a8a", lineHeight:1.6, margin:"4px 0 8px" },
  price:  { fontSize:22, fontWeight:800, color:"#1a3a5c", margin:"0 0 4px", fontFamily:"'Barlow Condensed',sans-serif" },
  dateChip: { fontSize:11, color:"#5a7a9a", background:"#f0f4f8", borderRadius:20, padding:"3px 10px" },
  statusBox: { display:"flex", alignItems:"center", gap:10, borderRadius:10, padding:"10px 12px", marginBottom:8 },
  intBtn:    { width:"100%", padding:"12px", borderRadius:12, background:"#1a3a5c", color:"white", border:"none", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" },
  cautionBtn:{ width:"100%", padding:"12px", borderRadius:12, background:"#2d6a0a", color:"white", border:"none", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginTop:4 },
  cancelBtn: { width:"100%", padding:"9px", borderRadius:10, background:"#f0f4f8", color:"#5a7a9a", border:"none", fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit", marginTop:4 },
  retryBtn:  { width:"100%", padding:"9px", borderRadius:10, background:"#f0f4f8", color:"#1a3a5c", border:"none", fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit", marginTop:4 },
  modalSummary: { background:"#f0f5fa", borderRadius:12, padding:"12px 14px", marginBottom:14 },
};
